if (!customElements.get('product-info-compact')) {
  customElements.define(
    'product-info-compact',
    class ProductInfoCompact extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.purchaseTypeSelectors = document.querySelectorAll('.purchase-type-selector > li');
        this.frequencySelectors = document.querySelectorAll('.purchase-type-selector .option-selector__frequency-selector');
        this.productTypeButtons = document.querySelectorAll('.product-form__product-type-button[data-url]');
        this.flavorButtons = document.querySelectorAll('.flavors-list .flavors-list__flavor > .flavor[data-url]');
        this.quantityButtons = document.querySelectorAll('.subscription-quantity li[data-pack]');
        this.bannerPurchaseTypeSelectors = document.querySelectorAll('#subscription-product-bar li [type="radio"]');
        this.bannerButtons = document.querySelectorAll('#subscription-product-bar .subscription-product-item .Button');
        this.mainFreeCreamerImage = document.querySelector('media-gallery .media-gallery__slider .slider__media-item:first-child');
        this.productGifts = this.querySelectorAll('.product__gifts [data-gift]');
        this.productType = this.dataset.productType;
        this.quantityButtonsVersion = this.dataset.quantityButtonsVersion || 'compact';
        this.cachedResults = {};
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        const navEntry = performance.getEntriesByType('navigation')[0];
        if (navEntry && navEntry.type === 'back_forward') {
            window.location.reload();
        }

        setTimeout(() => {
          this.setSelectorsAppearance();
          this.setEventListeners();
          this.setSelectorProductTypeSelector();
          this.prefetchProductData();
          /* Temp solution for BF */
          subscriptionOptions.is_deal_of_the_day && this.closest('.product')?.classList.remove('product-onetime')

          if (window.location.hash.includes('#buy-once') || subscriptionOptions.is_flavored_offer || subscriptionOptions.is_deal_of_the_day)
            this.setPurchaseType(this.querySelector('.option-selector-onetime'),)
        }, 300)

        document.body.classList.toggle('product-autodeliver', subscriptionOptions.currentRCType == 'autodeliver')
        document.body.classList.toggle('product-onetime', !(subscriptionOptions.currentRCType == 'autodeliver'))

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      setEventListeners() {
        this.purchaseTypeSelectors.forEach(selector => selector.addEventListener('click', () => this.setPurchaseType(selector)))
        this.flavorButtons.forEach(button => button.addEventListener('click', (event) => this.setFlavor(button)))
        this.productTypeButtons.forEach(button => button.addEventListener('click', () => this.setProductType(button)))
        this.quantityButtons.forEach(button => button.addEventListener('click', () => this.setQuantity(button)))
        this.frequencySelectors.forEach(selector => selector.addEventListener('change', this.setFrequency.bind(this)))
        this.bannerPurchaseTypeSelectors.forEach(selector => selector.addEventListener('change', () => this.setPurchaseType(selector)))
        this.bannerButtons.forEach(button => button.addEventListener('click', () => this.handleBannerButtonAction(button)))

        document.addEventListener('product:changed-quantity', event => {
          this.handleQuantityChange(event.detail.quantity)
        });

        ['product:changed-RCType', 'product:changed-quantity', 'product:variant:change'].forEach(eventName =>{
          document.addEventListener(eventName, event => {
            this.setGiftsAvailability(event.detail?.quantity)
          })
        })

        document.addEventListener('product:changed-quantity', event => {
          this.setQuantity(event.detail.quantity)
        });
      }

      handleQuantityChange(quantity) {
        const atcButton = this.querySelector('.product-form__buttons button[name="add"]') || this.querySelector('.product-bundle-form button.product-steps__add-to-cart');
        const atcButtonText = atcButton.querySelector('[data-button-text]')

        if(!atcButtonText) return

        const { requiredQuantity, requiredMessage, buttonMessage } = atcButton.dataset
        const productLeftToCheckout = +requiredQuantity - quantity

        atcButtonText.innerHTML = productLeftToCheckout > 0
          ? requiredMessage.replace('[items]', productLeftToCheckout)
          : buttonMessage

        atcButton.toggleAttribute('disabled', productLeftToCheckout > 0)
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      handleBannerButtonAction(button) {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const isPopupToggler = button.classList.contains('Button-subscription-popup');

        if (isPopupToggler) {
          document.getElementById('subscription-product-popup')?.openPopup(button);
        } else {
          this.querySelector('.product-form__buttons button[name="add"]')?.click();
        }
      }

      updateQuantityButtonsBadges() {
        const { currentRCType, discount_codes } = window.subscriptionOptions;
        if (!discount_codes) return;

        this.quantityButtons.forEach(button => {
          const buttonPack = +button.dataset.pack;
          const hasDiscountCode = discount_codes[currentRCType]?.find(discount => discount.quantity == buttonPack && discount.code);

          button.querySelector('.pack-discount')?.classList.toggle('pack-discount--accent', !!hasDiscountCode)
        })
      }

      async prefetchProductData() {
        if (!this.productTypeButtons?.length) return;
        const mainSectionId = this.dataset.section;
        const productTypeButtons = Array.from(this.productTypeButtons)
        const productUrls = new Set(productTypeButtons.map(typeButton => {
          const { url } = typeButton.dataset;

          return !url ? null : url;
        }))

        for (const productUrl of productUrls) {
          let html = null;

          try {
            if (this.cachedResults[productUrl]) {
              html = this.cachedResults[productUrl][mainSectionId];
            } else {
              const response = await this.fetchProductData(productUrl, false);
              if (!response.ok) return;
              html = await this.getHtmlResponse(response, productUrl);
              html = html[mainSectionId];
            }
          } catch(error) {
            console.error('Prefetching products error:' + error)
          }
        }
      }

      setSelectorProductTypeSelector() {
        const productTypes = this.querySelector('.product-form__product-types');
        if (!productTypes) return;

        const { selectorType } = productTypes.dataset;
        if (selectorType == 'built-in') return;

        const productSection = this.closest('.product');
        productSection.querySelector('.product__type-selector')?.appendChild(productTypes);
      }

      async setProductType(button) {
        const productSection = this.closest('.product');
        const productTypes = productSection?.querySelector('.product-form__product-types');

        const productUrl = button.getAttribute('data-url');
        const variantTitle = button.getAttribute('data-variant-title') || '';
        const mainSectionId = this.dataset.section;
        const isCurrentProductType = button.getAttribute('data-product-type') === window.subscriptionOptions?.currentProduct?.product?.type;

        if (productTypes) {
          const { selectorType } = productTypes.dataset;
          if (selectorType == 'step-selector') {
            productSection.querySelectorAll('.grid__item').forEach((element, index) => {
              element.classList.remove('grid__item--hidden');
              if (index === 0) element.scrollIntoView({block: 'start', behavior: 'smooth'})
            })
          };
        }


        const updateButtonPressedState = () => this.productTypeButtons.forEach(typeButton => typeButton.setAttribute('aria-pressed', button == typeButton));

        if (isCurrentProductType) {
          window.subscriptionOptions.option1 = variantTitle || window.subscriptionOptions.option1;
          this.setSelectorsAppearance();
          updateButtonPressedState();

          return;
        }

        let html = null;

        try {
          if (this.cachedResults[productUrl]) {
            html = this.cachedResults[productUrl][mainSectionId];
          } else {
            const response = await this.fetchProductData(productUrl, false);
            if (!response.ok) return;
            html = await this.getHtmlResponse(response, productUrl);
            html = html[mainSectionId];
          }

          if (!html) return;

          const subscriptionOptionsObject = this.buildSubscriptionOptionsObject(html, true);
          window.subscriptionOptions = subscriptionOptionsObject;

          const selectors = this.getSelectorsForProduct(false, true);
          this.updateDOMAndMedia(selectors, html, false);

          this.setSelectorsAppearance();
          updateButtonPressedState();
          if (typeof StampedFn !== 'undefined') StampedFn?.reloadUGC();
        } catch (error) {
          console.error(error);
        }
      }

      async setFlavor(button) {
        const productUrl = button.getAttribute('data-url');
        const isOfferProduct = this.productType === 'Offer';
        const isTeaProduct = window.subscriptionOptions.template === 'tea';

        let mainSectionId = this.dataset.section;
        const coffeeDetailsSectionId = document.querySelector('.coffee-details')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');
        const benefitsSectionId = document.querySelector('.landing-image-benefits__wrapper')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');

        let html = null;
        let detailsHtml = null;
        let benefitsHtml = null;

        try {
          if (this.cachedResults[productUrl]) {
            html = this.cachedResults[productUrl][mainSectionId];
            if (coffeeDetailsSectionId) detailsHtml = this.cachedResults[productUrl][coffeeDetailsSectionId];
            if (benefitsSectionId && isTeaProduct) benefitsHtml = this.cachedResults[productUrl][benefitsSectionId];
          } else {
            const response = await this.fetchProductData(productUrl, isOfferProduct);
            if (!response.ok) return;
            html = await this.getHtmlResponse(response, productUrl);
            html = html[mainSectionId];
            if (coffeeDetailsSectionId) detailsHtml = this.cachedResults[productUrl][coffeeDetailsSectionId];
            if (benefitsSectionId && isTeaProduct) benefitsHtml = this.cachedResults[productUrl][benefitsSectionId];
          }

          if (!html) return;

          this.updateFlavorButtonState(productUrl);
          const subscriptionOptionsObject = this.buildSubscriptionOptionsObject(html);

          window.subscriptionOptions = subscriptionOptionsObject;

          const selectors = this.getSelectorsForProduct(isOfferProduct);
          if (!isOfferProduct && isTeaProduct) selectors.push('.accordion__content .metafield-rich_text_field');
          this.updateDOMAndMedia(selectors, html, isOfferProduct);

          this.setSelectorsAppearance();
          if (typeof StampedFn !== 'undefined') StampedFn?.reloadUGC();
          if (coffeeDetailsSectionId) this.updateCoffeeDetails(detailsHtml, coffeeDetailsSectionId);
          if (benefitsSectionId && isTeaProduct) this.updateBenefitsSection(benefitsHtml, benefitsSectionId);
        } catch (error) {
          console.error(error);
        }
      }

      async fetchProductData(productUrl, isOfferProduct) {
        let mainSectionId = this.dataset.section;

        const coffeeDetailsSectionId = document.querySelector('.coffee-details')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');
        const benefitsSectionId = document.querySelector('.landing-image-benefits__wrapper')?.closest('section.shopify-section')?.id.replace('shopify-section-', '');

        let sectionIds = coffeeDetailsSectionId ? `${mainSectionId},${coffeeDetailsSectionId}` : mainSectionId;
        if (benefitsSectionId && window.subscriptionOptions.template === 'tea') sectionIds += `,${benefitsSectionId}`;
        const response = await fetch(`${productUrl}?sections=${sectionIds}${isOfferProduct ? '&view=subscription-creamer-offer' : ''}`);

        return response;
      }

      updateFlavorButtonState(productUrl) {
        this.flavorButtons.forEach(button => {
          const buttonUrl = button.dataset.url
          button.parentElement?.classList.toggle('flavors-list__flavor--active', productUrl === buttonUrl);
        });
      }

      async getHtmlResponse(response, productUrl) {
        const responseObject = await response.json();
        for (const key in responseObject) {
          responseObject[key] = new DOMParser().parseFromString(responseObject[key], 'text/html');
        }
        this.cachedResults[productUrl] = responseObject;
        return responseObject;
      }

      buildSubscriptionOptionsObject(html, isProductTypeSelector = false) {
        const subscriptionOptionsObject = JSON.parse(html.getElementById('subscription-options-object-json')?.innerText);
        const subscriptionOptionsObjectKeys = !isProductTypeSelector ?
          ['pack', 'pack_autodeliver', 'pack_onetime', 'shipping_interval_frequency', 'currentRCType'] :
          [];

        subscriptionOptionsObjectKeys.forEach(key => {
          subscriptionOptionsObject[key] = subscriptionOptions[key];
        });

        return subscriptionOptionsObject;
      }

      getSelectorsForProduct(isOfferProduct, isProductTypeSelector = false) {
        if (isProductTypeSelector) return ['.product-info--mobile .product__title', '.product-info--mobile .product-review-badge', '.product-info .product__title', '.product__flavors', '.purchase-type-selector', '.product-info .product-review-badge', '.product__description', '.subscription-quantity', '.product__features', 'media-gallery', 'product-modal', 'quick-buy-banner .thumbnail', 'quick-buy-banner .title', 'quick-buy-banner .product-review-badge', 'quick-buy-banner .Button-autodeliver.Button-subscription-popup .button__text', 'quick-buy-banner .Button-onetime .button__text', '.subscription-product-preview', '.coffee-details__grid', 'product-progress-bar', '.product__gifts', 'product-form'];

        return isOfferProduct
          ? ['.product-offer-subtitle', '.product-info--mobile .product-review-badge', '.product-info .product-review-badge', '.product__description', 'media-gallery', 'product-modal']
          : ['.product-info--mobile .product__title', '.product-info--mobile .product-review-badge', '.product-info .product__title', '.product-info .product-review-badge', '.product__description', '.product__features', 'media-gallery', 'product-modal', 'quick-buy-banner .thumbnail', 'quick-buy-banner .title', 'quick-buy-banner .product-review-badge', 'quick-buy-banner .Button-autodeliver.Button-subscription-popup .button__text', 'quick-buy-banner .Button-onetime .button__text', '.subscription-product-preview', '.coffee-details__grid'];
      }

      updateDOMAndMedia(selectors, html, isOfferProduct) {
        (this.closest('.product__section') || this).querySelectorAll('variant-selects').forEach(picker => {
          const sourcePicker = html.getElementById(picker.id);
          if (sourcePicker) picker.dataset.url = sourcePicker.dataset.url;
        });

        selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          const duplicatedElement = sourceElement?.cloneNode(true)

          if (targetElement && sourceElement && duplicatedElement) {
            targetElement.replaceWith(duplicatedElement);
          }

          if (['media-gallery', 'product-modal'].includes(selector)) {
            this.updateMediaGalleryOrModal(duplicatedElement, isOfferProduct, selector);
            if (typeof enableMagnifyZoom === 'function') enableMagnifyZoom();
          }

          if (['.product__flavors'].includes(selector)) {
            this.flavorButtons = document.querySelectorAll('.flavors-list .flavors-list__flavor > .flavor[data-url]');
            this.flavorButtons.forEach(button => button.addEventListener('click', (event) => this.setFlavor(button)));
          }

          if (['.subscription-quantity', '.purchase-type-selector'].includes(selector)) {
            this.quantityButtons = document.querySelectorAll('.subscription-quantity li[data-pack]');
            this.purchaseTypeSelectors = document.querySelectorAll('.purchase-type-selector > li');
            this.frequencySelectors = document.querySelectorAll('.purchase-type-selector .option-selector__frequency-selector');

            this.quantityButtons.forEach(button => button.addEventListener('click', () => this.setQuantity(button)));
            this.purchaseTypeSelectors.forEach(selector => selector.addEventListener('click', () => this.setPurchaseType(selector)));
            this.frequencySelectors.forEach(selector => selector.addEventListener('change', this.setFrequency.bind(this)));
          }

          if (['.product__gifts'].includes(selector)) {
            this.productGifts = this.querySelectorAll('.product__gifts [data-gift]');
          }
        });

        const requiredQuantity = +this.querySelector('[type="submit"]')?.dataset.requiredQuantity;
        subscriptionOptions.pack = isFinite(requiredQuantity) ? requiredQuantity : 1;

      }

      async updateMediaGalleryOrModal(sourceElement, isOfferProduct, selector) {
        const mediaGallerySwiperWrapper = sourceElement?.querySelector('.swiper-wrapper');
        const swipers = sourceElement?.querySelectorAll('[data-swiper]');

        if (mediaGallerySwiperWrapper && isOfferProduct && selector == 'media-gallery') {
          mediaGallerySwiperWrapper.insertBefore(this.mainFreeCreamerImage, mediaGallerySwiperWrapper.firstChild);
        }

        await window.loadSwiperAssets();

        swipers.forEach(swiper => {
          const options = swiper.dataset.swiper ? JSON.parse(swiper.dataset.swiper) : {};
          const mediaGallerySlider = new Swiper(swiper, options);
          mediaGallerySlider.slideTo(isOfferProduct ? 1 : 0);
        });
      }

      updateCoffeeDetails(html, sectionId) {
        if (!html || !sectionId) return;

        const targetElement = document.querySelector(`#shopify-section-${sectionId} .coffee-details`);
        const sourceElement = html.querySelector('.coffee-details');
        const duplicatedElement = sourceElement?.cloneNode(true)

        if (targetElement && sourceElement && duplicatedElement) {
          targetElement.replaceWith(duplicatedElement);
        }
      }

      updateBenefitsSection(html, sectionId) {
        if (!html || !sectionId) return;

        const targetElement = document.querySelector(`#shopify-section-${sectionId} .landing-image-benefits__container`);
        const sourceElement = html.querySelector('.landing-image-benefits__container');
        const duplicatedElement = sourceElement?.cloneNode(true)

        if (targetElement && sourceElement && duplicatedElement) {
          targetElement.replaceWith(duplicatedElement);
        }
      }

      updateDiscountCode(quantity) {
        const { discount_codes, currentRCType } = window.subscriptionOptions;
        if (!discount_codes) return;

        const currentDiscount = discount_codes[currentRCType]?.find((discount) => {
          return discount.quantity == quantity && discount.code;
        })

        window.subscriptionOptions.discount_codes.current_code = currentDiscount ? currentDiscount.code : null;
      }

      setQuantity(value) {
        const quantity = value;

        subscriptionOptions.pack = value;
        subscriptionOptions.pack_autodeliver = value;
        subscriptionOptions.pack_onetime = value;

        this.setSelectorsAppearance();
      }

      setFrequency(event) {
        const frequency = +event?.target?.value;
        if (!frequency && isFinite(frequency)) return;

        subscriptionOptions.shipping_interval_frequency = frequency;

        this.setSelectorsAppearance();
        document.dispatchEvent(new CustomEvent('product:frequency:change'));
      }

      setPurchaseType(selector, withoutLastFunction = false) {
        let purchaseType = selector.dataset.purchaseType;
        let isAutodeliver = purchaseType == 'autodeliver';

        this.purchaseTypeSelectors.forEach(element => element.classList.remove('active'))
        document.querySelectorAll(`.purchase-type-selector > li[data-purchase-type=${purchaseType}]`)?.forEach(selector => selector.classList.add('active'));

        if (isAutodeliver) {
          subscriptionOptions.currentRCType = 'autodeliver'
          this.querySelectorAll('[name="selling_plan"]').forEach(input => {
            input.removeAttribute('disabled')
          })
        } else {
          subscriptionOptions.currentRCType = 'onetime'
          this.querySelectorAll('[name="selling_plan"]').forEach(input => {
            input.setAttribute("disabled", '')
          })
        }

        if (document.querySelector('#subscription-product-bar') != null) {
          document.querySelector('#subscription-product-bar .Button-autodeliver').classList.add('hide');
          document.querySelector('#subscription-product-bar .Button-onetime').classList.add('hide');
          document.querySelector('#subscription-product-bar .Button-'+subscriptionOptions.currentRCType).classList.remove('hide');
          document.querySelector('#subscription-product-bar li [type="radio"][value="'+subscriptionOptions.currentRCType+'"]').checked = true;
        }

        document.body.classList.toggle('product-autodeliver', isAutodeliver)
        document.body.classList.toggle('product-onetime', !isAutodeliver)

        document.querySelectorAll('[data-benefits] > div[data-purchase-type]').forEach(benefitBlock => {
          const benefitPurchaseType = benefitBlock.dataset.purchaseType;
          benefitBlock.classList.toggle('hidden', benefitPurchaseType !== subscriptionOptions.currentRCType);
        })

        if (!withoutLastFunction) this.setSelectorsAppearance();

        document.dispatchEvent(new CustomEvent('product:changed-RCType'))
      }

      areVariantOptionsEquivalent(first, second) {
        if (first === second) return true;
        const groundOptions = ['Freshly Ground', 'Fine Grind'];
        return groundOptions.includes(first) && groundOptions.includes(second);
      }

      setVariantOptionsAvailability() {
        const { currentProduct, currentVariant, is_sold_out } = window.subscriptionOptions;
        const variants = currentProduct?.product?.variants;
        if (!variants) return;

        (this.closest('.product__section') || this).querySelectorAll('variant-selects').forEach(picker => {
          const optionValues = Array.from(picker.querySelectorAll('select, fieldset'), option =>
            Array.from(option.querySelectorAll('input[type="radio"], option'), input => input.value)
          );
          const pickerVariants = variants.map(variant => {
            const options = variant.options.map((value, index) =>
              optionValues[index]?.find(option => this.areVariantOptionsEquivalent(option, value)) || value
            );
            if (options.every((value, index) => value === variant.options[index])) return variant;
            return { ...variant, options, title: options.join(' / ') };
          });
          picker.variantData = pickerVariants;
          const variantJson = picker.querySelector('[type="application/json"]');
          if (variantJson) variantJson.textContent = JSON.stringify(pickerVariants);

          picker.querySelectorAll('.product-form__input').forEach((option, index) => {
            const availableValues = pickerVariants
              .filter(variant => variant.available && !is_sold_out &&
                Array.from({ length: index }, (_, previousIndex) => previousIndex + 1)
                  .every(position => variant[`option${position}`] === currentVariant?.[`option${position}`]))
              .map(variant => variant.options[index]);

            picker.setInputAvailability(
              [...option.querySelectorAll('input[type="radio"], option')],
              availableValues
            );
          });
        });
      }

      setSelectorsAppearance() {
        this.getSubscribeVariants();
        document.querySelector('quick-buy-banner')?.setAvailability(
          !subscriptionOptions?.currentVariant?.available || !!subscriptionOptions?.is_sold_out
        );
        this.setVariantOptionsAvailability();
        this.quantityButtonsVersion == 'compact' ? this.setQuantityButtonsCompact() : this.setQuantityButtonsDefault();
        this.setPrices();

        document.dispatchEvent(new CustomEvent('product:variant:change'))
      }

      setQuantityButtonsCompact() {
        let nowPack = subscriptionOptions.pack;

        const onetimeSelector = this.querySelector('.option-selector-onetime'),
          autodeliverSelector = this.querySelector('.option-selector-autodeliver');

        if (onetimeSelector && autodeliverSelector) {
          const stickyAutodeliverOption = document.getElementById('subscription-option-selector-popup-autodeliver')?.closest('li') || null;
          autodeliverSelector.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
          if (stickyAutodeliverOption) stickyAutodeliverOption.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
        }

        if (!subscriptionOptions.hasSubscribe) {
          subscriptionOptions.currentRCType = 'onetime';
          nowPack = subscriptionOptions.pack;

          if (onetimeSelector) {
            this.setPurchaseType(onetimeSelector, true);
          }
        }

        let quantityButtons = document.querySelectorAll('.subscription-quantity [data-pack]:not(.more)');
        quantityButtons.forEach(function (button){
          let purchaseType = button.dataset.purchaseType;
          button.classList.add('hidden')
          if (
            subscriptionOptions.currentRCType == 'autodeliver' && purchaseType == 'autodeliver' ||
            subscriptionOptions.currentRCType == 'onetime' && purchaseType == 'onetime' ||
            purchaseType == 'both'
          ) {
            button.classList.remove('hidden')
          }
        });
      }

      setQuantityButtonsDefault() {
        let nowPack = subscriptionOptions.currentRCType == 'autodeliver' ? subscriptionOptions.pack_autodeliver : subscriptionOptions.pack_onetime;

        const onetimeSelector = this.querySelector('.option-selector-onetime'),
          autodeliverSelector = this.querySelector('.option-selector-autodeliver');

        if (onetimeSelector && autodeliverSelector) {
          const stickyAutodeliverOption = document.getElementById('subscription-option-selector-popup-autodeliver')?.closest('li') || null;
          autodeliverSelector.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
          if (stickyAutodeliverOption) stickyAutodeliverOption.style.display = subscriptionOptions.hasSubscribe ? 'block' : 'none';
        }

        if (!subscriptionOptions.hasSubscribe) {
          subscriptionOptions.currentRCType = 'onetime';
          nowPack = subscriptionOptions.pack_onetime;

          if (onetimeSelector) {
            this.setPurchaseType(onetimeSelector, true);
          }
        }

        let nowPricePerUnit = 0;
        let percents = subscriptionOptions.onetimePercent;
        if (subscriptionOptions.currentRCType == 'autodeliver') {
          percents = subscriptionOptions.autodeliverPercent;
        }

        let autodeliverDiscountValueMax = subscriptionOptions.autodeliverPercent[subscriptionOptions.autodeliverPercent.length - 1];

        document.querySelectorAll('.purchase-type-selector .option-selector-autodeliver .discount-label').forEach(function(discountBox){
          discountBox.innerHTML = '<span class="discount-label--percentage">' + autodeliverDiscountValueMax + '</span>%';
        });

        let shippingInfoRow = this.querySelectorAll('.ProductForm_shipping_info-row');
        shippingInfoRow.forEach(function(row){
          row.classList.remove('autodeliver');
          row.classList.remove('onetime');
          row.classList.add(subscriptionOptions.currentRCType);
        });

        let percentsLength = percents.length;
        let  discountCode = '';
        let  discountLabel = '';
        if (nowPack > percentsLength) {
          discountLabel = 'SAVE';
          discountCode = percents[percentsLength-1] + '%';
        } else {
          for (var i in percents) {
            if (i == nowPack-1 && percents[i] != 0) {
              discountLabel = 'SAVE';
              discountCode = percents[i] + '%';
            }
          }
        }
        let quantityButtons = document.querySelectorAll('.subscription-quantity [data-pack]:not(.more)');
        quantityButtons.forEach(function (button){
          button.querySelector('.pack-discount').innerHTML = '';
          let pack = parseInt(button.getAttribute('data-pack'));
          if (pack < percentsLength) {
            pack = pack - 1;
          } else {
            pack = percentsLength - 1;
          }
          if (percents[pack]) {
            button.querySelector('.pack-discount').classList.remove('hide');
          } else {
            button.querySelector('.pack-discount').classList.add('hide');
          }
          button.querySelector('.pack-discount').innerHTML = percents[pack] ? 'SAVE ' + percents[pack] + '%': '';

          let purchase_type = button.dataset.purchaseType;
          button.classList.add('hidden')
          if (
            subscriptionOptions.currentRCType == 'autodeliver' && purchase_type == 'autodeliver' ||
            subscriptionOptions.currentRCType == 'onetime' && purchase_type == 'onetime' ||
            purchase_type == 'both'
          ) {
            button.classList.remove('hidden')
          }

          const { is_deal_of_the_day, onetime_packs, currentRCType, product_name } = subscriptionOptions;
          const currentQuantity = parseInt(button.getAttribute('data-pack'));

          if (is_deal_of_the_day && currentQuantity >= onetime_packs[0] && currentRCType == 'onetime' || product_name == 'Black Friday Limited Edition') {
            button.querySelector('.pack-discount').innerHTML = 'BF SALE';
            button.classList.add('quantity--bf')
          }
        });

        const currentVolumeDiscounts = subscriptionOptions.currentRCType == 'onetime' ? subscriptionOptions.volume_discounts_onetime : subscriptionOptions.volume_discounts_subs
        setButtonPrices(currentVolumeDiscounts);

        document.querySelectorAll('.subscription-arrow-quantity-box .quantity-discount-box').forEach(function(discountBox){
          if (discountCode != '' && discountCode != 'undefined%') {
            discountBox.classList.remove('hide');
          } else {
            discountBox.classList.add('hide');
          }
          discountBox.innerHTML = discountLabel+' '+discountCode;

          const { is_deal_of_the_day, onetime_packs, currentRCType } = subscriptionOptions;
          if (is_deal_of_the_day && nowPack >= onetime_packs[0] && currentRCType == 'onetime') {
            discountBox.innerHTML = 'BF SALE'
          }
        });

        document.querySelectorAll('.subscription-detail .discount').forEach(discountLabel => {
          discountLabel.innerHTML = 'Save ' + discountCode;
        })

        if (nowPricePerUnit) {
          document.querySelectorAll('.subscription-arrow-quantity-box .price-per-unit').forEach(function(discountBox){
            discountBox.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (nowPricePerUnit / 100));
            if (window.templateSuffix == 'subscription-bundle-new' || window.templateSuffix == 'statick-quantity') {
              let wrapperForBundles = document.querySelector('.price-per-bundle')
              let dividerForPrice = +document.querySelector('.subscription-quantity .pack-icon-name .pack-icon').innerText
              let dividerForBundle = +document.querySelector('.quantity-input-box .quantity-number').innerText
              let bagPrice =  window.theme.moneyFormat.replace('{{amount}}', (nowPricePerUnit / 100 / dividerForPrice));
              let priceForBundles = window.theme.moneyFormat.replace('{{amount}}', ((nowPricePerUnit / dividerForPrice / 100) * dividerForBundle).toFixed(2));
              wrapperForBundles.innerHTML = priceForBundles
              let bagPriceStr = bagPrice.toString()
              let bagPriceArr = Array.from(bagPriceStr.split('.')[1])
              let bagPriceNew = bagPriceStr.split('.')[0] + '.' + bagPriceArr[0] + '' + bagPriceArr[1]
              discountBox.innerHTML = bagPriceNew
            }
          });
        }

        document.querySelectorAll('.subscription-arrow-quantity-box .quantity-number').forEach(function(qtyNumber){
          let pack = nowPack;
          if (subscriptionOptions.template == 'pod') {
            if (subscriptionOptions.unit_step == 12) {
              if (pack != 1) {
                pack = (pack - 1) * 2;
              }
            }
          }
          if (subscriptionOptions.product_name == 'Limited Release: Dur Feres. Ethiopia' || subscriptionOptions.product_name == 'Limited Release: Todos Santos. Guatemala' || subscriptionOptions.product_name == 'Mother’s Day Special – 12 Oz' ) {
            qtyNumber.innerHTML = subscriptionOptions.pack
            subscriptionOptions.pack_onetime = subscriptionOptions.pack
          } else if (subscriptionOptions.currentProduct?.product.tags.includes('Product-Sell-Out')) {
            if (subscriptionOptions.template == 'pod') {
              qtyNumber.innerHTML = subscriptionOptions.pack * subscriptionOptions.unit_step
              subscriptionOptions.pack_onetime = subscriptionOptions.pack
            } else {
              qtyNumber.innerHTML = subscriptionOptions.pack
              subscriptionOptions.pack_onetime = subscriptionOptions.pack
            }
          } else {
            qtyNumber.innerHTML = pack*subscriptionOptions.unit_step;
          }
        });

        let isSubscribeWithOnePack = subscriptionOptions.pack == 1 && subscriptionOptions.currentRCType == 'autodeliver',
          currentVariant = isSubscribeWithOnePack ? subscriptionOptions.currentProduct?.product?.variants[0] : subscriptionOptions.currentVariant,
          currentProduct = isSubscribeWithOnePack ? subscriptionOptions.currentProduct.product : subscriptionOptions.currentProduct,
          pack = subscriptionOptions.currentRCType == 'autodeliver' ? subscriptionOptions.pack_autodeliver : subscriptionOptions.pack_onetime,
          compare_at_price = currentVariant.compare_at_price ? currentVariant.compare_at_price * pack : currentVariant.price * pack,
          regular_price = subscriptionOptions.volume_discounts_onetime?.length ? getCurrentDiscountedPrice(subscriptionOptions, pack, 'onetime') * pack : currentVariant.price * pack,
          subscribe_price = subscriptionOptions.hasSubscribe ? getCurrentDiscountedPrice(subscriptionOptions, pack, 'autodeliver') * pack : 0;

        subscriptionOptions.regular_price = regular_price;
        subscriptionOptions.subscribe_price = subscribe_price;

        document.body.querySelectorAll('.price-subscribe, .price-buynow').forEach(function (item) {
          const currentPrice = subscriptionOptions.currentRCType == 'autodeliver' ? subscribe_price : regular_price;

          item.innerHTML = window.theme.moneyFormat.replace('{{amount}}', (currentPrice / 100));
        });

        if (subscriptionOptions.currentProduct.subscription) {
          let optionText = subscriptionOptions.option1;
          if (subscriptionOptions.template == 'pod' || optionText == 'Default Title') {
            optionText = '';
          }

          let labelText = nowPack + ' ';
          if (nowPack == 1) {
            labelText += subscriptionOptions.quantity_label[0];
          } else {
            labelText += subscriptionOptions.quantity_label[1];
          }
          labelText += ' Every ' + subscriptionOptions.shipping_interval_frequency + ' Weeks';

          if(document.querySelector('.subscription-product-preview')){
            document.querySelector('.subscription-product-preview .option').innerHTML = optionText;
            document.querySelector('.subscription-product-preview .label').innerHTML = labelText;
          }
        }

        const currentPrice = subscriptionOptions.currentRCType == 'autodeliver' ? subscribe_price : regular_price;
        this.setKlaviyoItemPrices(currentPrice, compare_at_price)

        function setButtonPrices(volumeDiscounts) {
          if (!volumeDiscounts.length) {
            nowPricePerUnit = subscriptionOptions.currentVariant.price;
            quantityButtons.forEach(function(button) {
              button.querySelector('.price-per-unit').innerHTML = window.theme.moneyFormat.replace('{{amount}}', (subscriptionOptions.currentVariant.price / 100).toFixed(2));
              button.querySelector('.price-per-unit-label').innerHTML = ' each';
            });
            return;
          }

          volumeDiscounts.map(function(discount){
            const volumeQuantity = discount.split('--')[0];
            const volumePrice = Math.round(+discount.split('--')[1] * 100);

            quantityButtons.forEach(function(button){
              let pack = parseInt(button.getAttribute('data-pack'));

              if (pack >= volumeQuantity.replace('+', '')) {
                let price = 0;
                if (volumePrice) price = volumePrice || 0;

                if (subscriptionOptions.unit_step == 4 || subscriptionOptions.unit_step == 3) {
                  price = price/subscriptionOptions.unit_step;
                }
                button.querySelector('.price-per-unit').innerHTML = window.theme.moneyFormat.replace('{{amount}}', (price / 100).toFixed(2));
                button.querySelector('.price-per-unit-label').innerHTML = ' each';
              }
            });
            if (nowPack >= volumeQuantity.replace('+', '') && volumePrice) {
              nowPricePerUnit = volumePrice;
            }
          });
        }

        function getCurrentDiscountedPrice(product, currentQuantity, purchaseType = 'onetime') {
          const prices = purchaseType == 'autodeliver' ? product.volume_discounts_subs : product.volume_discounts_onetime;
          if (!prices) return 0;

          const maxVolumeQuantity = prices[prices.length - 1].split('--')[0].replace('+', '');

          const discountPerItem = prices.find((value) => {
            const quantity = value.split('--')[0].replace('+', '');
            return +quantity === currentQuantity || +quantity === +maxVolumeQuantity;
          })?.split('--')[1];

          return Math.round(discountPerItem * 100);
        }
      }

      setPrices() {

        let {
          pack,
          currentVariant,
          hasSubscribe,
          volume_discounts_onetime,
          currentRCType,
          option1,
          template,
          quantity_label,
          autodeliverPercent,
          onetimePercent,
        } = subscriptionOptions;

        const requiredQuantity = this.querySelector('[type="submit"]')?.dataset.requiredQuantity || 0

        pack = pack >= requiredQuantity ? pack : 0

        const formatMoney = value =>
          window.theme.moneyFormat.replace('{{amount}}', ((value / 100).toFixed(2)));

        const getDiscountedPrice = (product, qty, type = 'onetime') => {
          const prices =
            type === 'autodeliver'
              ? product.volume_discounts_subs
              : product.volume_discounts_onetime;
          if (!prices) return 0;

          const maxQty = +prices.at(-1).split('--')[0].replace('+', '');
          const discount = prices.find(value => {
            const quantity = +value.split('--')[0].replace('+', '');
            return quantity === qty || quantity === maxQty;
          })?.split('--')[1];

          return Math.round(discount * 100);
        };

        const getPriceByType = (isAutodeliver, total = true) =>
          isAutodeliver
            ? (total ? subscribePrice : subscribePrice / pack)
            : (total ? regularPrice : regularPrice / pack);

        const comparePrice = (currentVariant.compare_at_price || currentVariant.price) * pack;
        const regularPrice = volume_discounts_onetime?.length
          ? getDiscountedPrice(subscriptionOptions, pack, 'onetime') * pack
          : currentVariant.price * pack;
        const subscribePrice = hasSubscribe
          ? getDiscountedPrice(subscriptionOptions, pack, 'autodeliver') * pack
          : 0;
        const currentPrice = currentRCType === 'autodeliver' ? subscribePrice : regularPrice;

        subscriptionOptions.regular_price = regularPrice;
        subscriptionOptions.subscribe_price = subscribePrice;

        const getDiscountPercents = (discountsArray) => {
          const originalPrice = subscriptionOptions.currentVariant?.compare_at_price || subscriptionOptions.currentVariant?.price;
          let discountPercents = [];

          for (let i = 0; i < discountsArray.length; i++) {
            const discountString = discountsArray[i]?.split('--');
            const price = Math.round(+discountString[1] * 100);
            const discountPercent = Math.round((originalPrice - price) / originalPrice * 100);
  
            discountPercents.push(discountPercent);
          }

          return discountPercents;
        }

        const updateMainPrices = () => {
          document.querySelectorAll('.price-subscribe, .price-buynow').forEach(node => (node.innerHTML = formatMoney(currentPrice)));
        };

        const updateSubscriptionPreview = () => {
          if (!hasSubscribe) return;
          const optionText = (template === 'pod' || option1 === 'Default Title') ? '' : option1;
          const labelText = `${pack} ${pack === 1 ? quantity_label[0] : quantity_label[1]} Every 4 Weeks`;

          document.querySelector('.subscription-product-preview .option').innerHTML = optionText;
          document.querySelector('.subscription-product-preview .label').innerHTML = labelText;
        };

        const updateOriginalPrices = () => {
          document.querySelectorAll('[data-price-original]')
            .forEach(node => {
              node.innerHTML = formatMoney(comparePrice);
              node.classList.toggle('hidden', comparePrice <= currentPrice);
            });
        };

        const updateCurrentPrices = () => {
          document.querySelectorAll('[data-price-current]')
            .forEach(node => {
              if (!node.hasAttribute('data-autodeliver') && !node.hasAttribute('data-onetime')) {
                const isAutodeliver = subscriptionOptions.currentRCType === 'autodeliver';
                const price = getPriceByType(isAutodeliver);
                node.innerHTML = formatMoney(price);
              } else {
                const price = getPriceByType(node.hasAttribute('data-autodeliver'));
                node.innerHTML = formatMoney(price);
              }
            });
        };

        const updatePerPackPrices = () => {
          document.querySelectorAll('[data-price-pack]')
            .forEach(node => {
              const price = getPriceByType(node.hasAttribute('data-autodeliver'), false);
              node.innerHTML = formatMoney(price || 0);
            });
        };

        const updateDiscountLabels = () => {
          document.querySelectorAll('[data-discount-percent]').forEach(label => {
            const isAutodeliver = label.hasAttribute('data-autodeliver');
            const percents = isAutodeliver ? autodeliverPercent : onetimePercent;

            let currentPercent = percents.at(-1);
            if (pack <= percents.length) currentPercent = percents[pack - 1];

            if (currentPercent === undefined || currentPercent === 'undefined') currentPercent = 0;

            label.closest('.option-selector__discount-badge')
              ?.classList.toggle('hidden', currentPercent <= 0);
            label.closest('.option-selector__heading')
              ?.querySelector('.option-selector__volume-prices')
              ?.classList.toggle('option-selector__volume-prices--no-discount', currentPercent <= 0);

            label.innerHTML = currentPercent;

            if (isAutodeliver) {
              document.querySelectorAll('.subscription-detail .discount')
                .forEach(discountLabel => {
                  discountLabel.innerHTML = `Save ${currentPercent}%`;
                });
            }
          });

          document.querySelectorAll('[data-discount-percent-original]').forEach(label => {
            const isAutodeliver = label.hasAttribute('data-autodeliver');
            const purchaseTypeKey = isAutodeliver ? 'autodeliver' : 'onetime';
            const { volume_discounts_original } = window.subscriptionOptions;

            if (!volume_discounts_original || !volume_discounts_original[purchaseTypeKey]) return;

            const percents = getDiscountPercents(volume_discounts_original[purchaseTypeKey]);
            let currentPercent = percents.at(-1);
            if (pack <= percents.length) currentPercent = percents[pack - 1];

            if (currentPercent === undefined || currentPercent === 'undefined') currentPercent = 0;
            label.innerHTML = currentPercent;
          })
        };

        updateMainPrices();
        updateSubscriptionPreview();
        updateOriginalPrices();
        updateCurrentPrices();
        updatePerPackPrices();
        updateDiscountLabels();

        this.setKlaviyoItemPrices(currentPrice, comparePrice);
      }

      setSellingPlan() {
        const currentProduct = window.subscriptionOptions?.currentProduct?.product || null;
        if (!currentProduct);

        const currentFrequencyNumber = window.subscriptionOptions.shipping_interval_frequency?.toString();
        const sellingPlanInputs = this.querySelectorAll('input[name="selling_plan"]');
        const sellingPlansGroups = currentProduct ? currentProduct?.selling_plan_groups : null;

        if (sellingPlansGroups && sellingPlansGroups[0]) {
          for (let i = 0; i < sellingPlansGroups[0].selling_plans.length; i++) {
            const sellingPlan = sellingPlansGroups[0].selling_plans[i];

            if (sellingPlan.name.split(' ').includes(currentFrequencyNumber)) {
              sellingPlanInputs.forEach(input => {
                input.value = sellingPlan.id;
              })
              break;
            }
          }
        }
      }

      setKlaviyoItemPrices(price, compareAtPrice) {
        if (typeof klaviyoItem != 'undefined') {
          klaviyoItem.CompareAtPrice = window.theme.moneyFormat.replace('{{amount}}', (compareAtPrice / 100));
          klaviyoItem.Price = window.theme.moneyFormat.replace('{{amount}}', (price / 100));
        }
      }

      setGiftsAvailability(quantity) {
        subscriptionOptions.pack = quantity || subscriptionOptions.pack || 1
        const currentPack = subscriptionOptions.pack;

        this.productGifts.forEach(gift => {
          const { requiredQuantityOnce, requiredQuantitySubscription } = gift.dataset;
          const isAutodeliver = subscriptionOptions.currentRCType === 'autodeliver';
          const requiredQuantity = isAutodeliver ? parseInt(requiredQuantitySubscription) : parseInt(requiredQuantityOnce);
          const quantityTextBlock = gift.querySelector('[data-required-quantity-block]');
          const currentParentId = this.querySelector('product-flavor:has([data-id-input][form])')?.idInput.value;

          if (!currentParentId) return;

          if (quantityTextBlock) quantityTextBlock.innerHTML = requiredQuantity;
          gift.classList.toggle('product-gift--locked', currentPack < requiredQuantity);
          gift.querySelectorAll('input').forEach(input => {
            input.disabled = currentPack < requiredQuantity;
            if (input.name.includes('parent_id') || input.name.includes('_landing_gift')) input.value = currentParentId;
          });
        })
      }

      getSubscribeVariants() {
        let currentProduct = subscriptionOptions.currentProduct?.product || null;
        let currentVariant = null;
        let hasSubscribe = subscriptionOptions.hasSubscribe || 0;

        if (currentProduct != null) {
          for (let i in currentProduct.variants) {
            if (
              (this.areVariantOptionsEquivalent(currentProduct.variants[i].option1, subscriptionOptions.option1)) &&
              (currentProduct.variants[i].option2 == null || currentProduct.variants[i].option2 == subscriptionOptions.option2) &&
              (currentProduct.variants[i].option3 == null || currentProduct.variants[i].option3 == subscriptionOptions.option3)
            ) {
              currentVariant = currentProduct.variants[i];
              subscriptionOptions.currentVariantID = currentVariant.id;
            }
          }
        }

        let autoDiscounts = [], onetimeDiscounts = [];
        const subsDiscountMetafield = subscriptionOptions.volume_discounts_subs,
          onetimeDiscountsMetafield = subscriptionOptions.volume_discounts_onetime,
          originalPrice = subscriptionOptions.currentVariant?.compare_at_price || subscriptionOptions.currentVariant?.price;

        getDiscountPercents(onetimeDiscountsMetafield, 'onetime')
        if (hasSubscribe) getDiscountPercents(subsDiscountMetafield, 'subscription')

        subscriptionOptions.autodeliverPercent = autoDiscounts;
        subscriptionOptions.onetimePercent = onetimeDiscounts;
        subscriptionOptions.currentProduct.product = currentProduct;
        subscriptionOptions.currentVariant = currentVariant;

        const previewOptionText = subscriptionOptions.template === 'pod' || subscriptionOptions.option1 === 'Default Title'
          ? '' : subscriptionOptions.option1 || '';
        (this.closest('.product__section') || this).querySelectorAll('.subproduct-preview-item .option').forEach(option => {
          option.textContent = previewOptionText;
        });

        /* Set new selling plan ID */
        if (!document.querySelector('html').getAttribute('page.subscription-v2')) {
          setTimeout(() => {
            this.setSellingPlan();
          }, 0)
        }

        this.querySelectorAll('input[name="id"]').forEach(input => {
          input.value = subscriptionOptions.currentVariantID
        })

        this.querySelectorAll('input[name="quantity"]').forEach(input => {
          input.value = subscriptionOptions.pack;
        })

        function getDiscountPercents(discountsArray, purchaseType) {
          for (let i = 0; i < discountsArray.length; i++) {
            const discountString = discountsArray[i]?.split('--');
            const price = Math.round(+discountString[1] * 100);
            const discountPercent = Math.round((originalPrice - price) / originalPrice * 100);

            purchaseType == 'subscription' ? autoDiscounts.push(discountPercent) : onetimeDiscounts.push(discountPercent)
          }
        }
      }
    }
  );
}

if (!customElements.get('subscription-product-popup')) {
  customElements.define(
    'subscription-product-popup',
    class SubscriptionProductPopup extends HTMLElement {
      constructor() {
        super();
        this.closeButton = this.querySelector('#subscription-close-btn')
        this.addToCartButton = this.querySelector('.subscription-popup__button');
      }

      connectedCallback() {
        this.attachEventListeners();
      }

      attachEventListeners() {
        this.closeButton?.addEventListener('click', this.closePopup.bind(this));
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          event.stopPropagation();
          this.closePopup();
        });
        this.addToCartButton?.addEventListener('click', this.handleATCButtonClick)
      }

      openPopup(trigger) {
        this.trigger = trigger;
        document.body.classList.add('subscription-open');
        trapFocus(this, this.closeButton || this);
      }

      closePopup() {
        document.body.classList.remove('subscription-open');
        removeTrapFocus(this.trigger);
      }

      handleATCButtonClick() {
        document.querySelector('.product-form__buttons button[name="add"]')?.click();
      }
    }
  )
}

if (!customElements.get('quick-buy-banner')) {
  customElements.define(
    'quick-buy-banner',
    class QuickBuyBanner extends HTMLElement {
      constructor() {
        super();

        this.autodeliverLabel = this.querySelector('.option-selector-autodeliver label');
        this.autodeliverInput = this.querySelector('.option-selector-autodeliver input[type="radio"]');
      }

      connectedCallback() {
        window.addEventListener('scroll', this.toggleSubscriptionBar);
      }

      setAvailability(isUnavailable) {
        this.querySelectorAll('.Button').forEach(button => {
          button.classList.toggle('Button--sold-out', isUnavailable);
          button.setAttribute('aria-disabled', String(isUnavailable));
          button.disabled = isUnavailable;

          const label = button.querySelector('.button__text');
          if (!label) return;
          if (!label.dataset.availableText && !isUnavailable) label.dataset.availableText = label.textContent;
          label.textContent = isUnavailable ? window.variantStrings.soldOut : label.dataset.availableText;
        });
      }

      toggleSubscriptionBar() {
        let subscriptionSection = document.querySelector('.product__section');
        if (subscriptionSection) {
          var windowOffset = window.pageYOffset;
          var sectionHeight = subscriptionSection.clientHeight;
          var sectionOffset = subscriptionSection.offsetTop;
          sectionOffset = sectionOffset + sectionHeight;

          if (windowOffset >= sectionOffset) {
            document.body.classList.add('subscription-bar-open');
          } else {
            document.body.classList.remove('subscription-bar-open');
          }
        }
      }

    }
  )
}

if (!customElements.get('product-flavor')) {
  customElements.define(
    'product-flavor',
    class ProductFlavor extends HTMLElement {
      constructor() {
        super();

        this.productData = JSON.parse(this.querySelector('[type="application/json"]').innerHTML || '{}')

        this.formId = this.dataset.formId
        this.idInput = this.querySelector('[data-id-input]')
        this.sellingPlanInput = this.querySelector('[data-selling-plan-input]')


        this.wrapper = this.closest('.flavors-list__flavor') || this
        this.quantityInput = this.querySelector('.quantity__input');

        if(!this.quantityInput) return

        this.addEventListener('click', this.clickHandler.bind(this))
        document.addEventListener('product:variant:change', this.variantChangeHandler.bind(this))
        this.sellingPlanInput && document.addEventListener('product:changed-RCType', this.handleChangeRCType.bind(this))
        this.sellingPlanInput && document.addEventListener('product:frequency:change', this.updateSellingPlan.bind(this))

        this.quantityInput.addEventListener('change', () => {
          this.wrapper.classList.toggle('flavors-list__flavor--active', +this.quantityInput.value)

          this.toggleFromInputs(+this.quantityInput.value)
        })
      }

      handleChangeRCType(){
        this.sellingPlanInput.toggleAttribute('disabled', window.subscriptionOptions.currentRCType != 'autodeliver')
      }

      updateSellingPlan(){
        let currentFrequencyNumber = subscriptionOptions.shipping_interval_frequency?.toString();
        let sellingPlansGroups = this.productData?.selling_plan_groups;

        if (sellingPlansGroups && sellingPlansGroups[0]) {
          for (let i = 0; i < sellingPlansGroups[0].selling_plans.length; i++) {
            const sellingPlan = sellingPlansGroups[0].selling_plans[i];

            if (sellingPlan.name.split(' ').includes(currentFrequencyNumber)) {
              this.sellingPlanInput.value = sellingPlan.id;
              break;
            }
          }
        }
      }

      clickHandler(event) {
        if(event.target.closest('quantity-input')) return;

        this.quantityInput.value = +this.quantityInput.value > 0 ? 0 : 1
        this.quantityInput.dispatchEvent(new Event('change', {bubbles: true}));
      }

      toggleFromInputs(enabled){
        this.querySelectorAll('input').forEach(input => {
          enabled ? input.setAttribute('form', this.formId)
            : input.removeAttribute('form')
        })
      }

      variantChangeHandler(){
        const currentVariant = window.subscriptionOptions.currentVariant

        const selectedVariant = this.productData.variants.find(variant => {
          return (variant.option1 == currentVariant.option1) &&
            (variant.option2 == null || variant.option2 == currentVariant.option2) &&
            (variant.option3 == null || variant.option3 == currentVariant.option3) ||
            (this.productData.title == "Espresso - 12oz" && variant.option1 == 'Fine Grind' && currentVariant.option1 == 'Freshly Ground')
        })

        if(!selectedVariant) return

        this.idInput.value = selectedVariant.id;
      }
    }
  )
}

if (!customElements.get('product-flavors')) {
  customElements.define(
    'product-flavors',
    class ProductFlavors extends HTMLElement {
      constructor() {
        super();

        this.flavors = this.querySelectorAll('product-flavor')

        if(!this.flavors) return

        this.addEventListener('change', event => {
          const quantity = [...this.flavors].reduce((accumulator, currentValue) => accumulator + +currentValue.quantityInput.value, 0)

          document.dispatchEvent(new CustomEvent('product:changed-quantity', {
            detail: {
              quantity: quantity
            }
          }))
        })
      }
    }
  )
}

if (!customElements.get('product-progress-bar')) {
  customElements.define(
    'product-progress-bar',
    class ProductProgressBar extends HTMLElement {
      constructor() {
        super();

        this.quantity = this.dataset.initialQuantity || 1;
        this.config = JSON.parse(this.querySelector('[type="application/json"]')?.innerHTML || '{}')
        this.stepWrappers = this.querySelectorAll('.progress-bar__unit')
        this.achievementMessageElement = this.querySelector('.progress-bar__achievement')


        document.addEventListener('product:changed-quantity', event => {
          this.setQuantity(event.detail.quantity)
        })

        document.addEventListener('product:changed-RCType', event => {
          this.handleChangeRCType()
        })
      }

      handleChangeRCType(){
        const currentSettings = window.subscriptionOptions.currentRCType == "autodeliver"
          ? this.config.subscription : this.config.onetime

        this.stepWrappers.forEach((stepWrapper, index) => {
          if(index === 0) return;

          const priceElement = stepWrapper.querySelector('[data-price]')
          const discountElement = stepWrapper.querySelector('[data-discount]')

          discountElement && (discountElement.innerHTML = currentSettings.discountValues[index])

          const discountedPrice = ((100 - currentSettings.discountValues[index]) / 100) * window.subscriptionOptions.currentVariant.price
          priceElement && (priceElement.innerHTML = window.theme.moneyFormat.replace('{{amount}}', ((discountedPrice / 100).toFixed(2))))

          this.updateDiscount()
        })
      }

      setQuantity(value) {
        this.quantity = value
        this.stepWrappers.forEach((stepWrapper, index) => {
          if(index === 0) return;

          const progressElement = stepWrapper.querySelector('progress');
          const breakpoint = this.config.steps[index]
          const prevBreakpoint = this.config.steps[index - 1]

          progressElement.value = value - prevBreakpoint
          stepWrapper.classList.toggle('progress-bar__unit--active', value >= breakpoint)
        })

        this.updateDiscount()

        const nextAchievementStep = this.config.steps.find(step => step > value);
        const isFollowingStep = this.config.steps.indexOf(nextAchievementStep) !== 0 && this.config.steps.indexOf(nextAchievementStep) !== 1;
        const achivementMessage = isFollowingStep ? this.config.biggerAchievementMessage : this.config.achievementMessage;
        
        this.achievementMessageElement.classList.toggle('hidden', !nextAchievementStep)

        if(!nextAchievementStep) return
        this.achievementMessageElement.textContent = achivementMessage.replace('[items]', nextAchievementStep - value)
      }

      updateDiscount(){
        const currentSettings = window.subscriptionOptions.currentRCType == "autodeliver"
          ? this.config.subscription : this.config.onetime

        const lastAchievement = Math.max(0, this.config.steps.filter(step => step <= this.quantity).length - 1)
        window.subscriptionOptions.landingDiscount = currentSettings.discountCodes[lastAchievement]
      }
    }
  )
}